import React from 'react';
import { Tabs } from 'antd';
import './tabs.scss';
//const { TabPane } = Tabs; // No longer used by Ant Design (deprecated)

interface TabComponentProps {
    defaultActiveKey?: string;
    type?: 'card' | 'line' | 'editable-card';
    tabComponent: { tab: string; component: React.ReactNode }[];
    onTabClick?: (key: string) => void;
    activeTab?: number;
    position?: 'top' | 'bottom' | 'left' | 'right';
}

const TabComponent = ({
    defaultActiveKey = '0',
    type = 'card',
    tabComponent = [],
    onTabClick,
    activeTab,
    position = 'top',
}: TabComponentProps) => {
    // Use controlled mode if activeTab is provided, otherwise use uncontrolled
    const isControlled = activeTab !== undefined;
    
    const handleChange = (key: string) => {
        if (onTabClick) {
            onTabClick(key);
        }
    };
 
    return (
        <div>
            <Tabs
                tabPosition={position}
                defaultActiveKey={!isControlled ? defaultActiveKey : undefined}
                type={type}
                activeKey={isControlled ? activeTab.toString() : undefined}
                onChange={handleChange}
                items={tabComponent.map((tab, index) => {
                    const label = tab.tab;
                    const key = index.toString();
                    const children = tab.component;
                    return {
                        label:label,
                        key:key,
                        children:children
                    }
                })}
                indicator={{size: 50, align: 'center'}}
            >
            </Tabs>
        </div>
    );
};

export default TabComponent;
